import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ContactOriginRequest, ContactOriginResponse, PageResponse } from '../models/contact-origin.model';

@Injectable({
  providedIn: 'root'
})
export class ContactOriginApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-origins?businessId=&page=&size=
  getOrigins(businessId: number, page = 0, size = 100): Observable<ContactOriginResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<ContactOriginResponse>>(`${this.apiUrl}/contact-origins`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/contact-origins/{id}?businessId=
  getOriginById(id: number, businessId: number): Observable<ContactOriginResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactOriginResponse>(`${this.apiUrl}/contact-origins/${id}`, { params });
  }

  // POST /api/contact-origins
  createOrigin(origin: ContactOriginRequest): Observable<ContactOriginResponse> {
    return this.http.post<ContactOriginResponse>(`${this.apiUrl}/contact-origins`, origin);
  }

  // PUT /api/contact-origins/{id}
  updateOrigin(id: number, origin: ContactOriginRequest): Observable<ContactOriginResponse> {
    return this.http.put<ContactOriginResponse>(`${this.apiUrl}/contact-origins/${id}`, origin);
  }

  // DELETE /api/contact-origins/{id}?businessId=
  deleteOrigin(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-origins/${id}`, { params });
  }
}
